// Shared risk helpers for color/band logic
export const bandOfScore = (score) => {
  if (score <= 30) return "Low";
  if (score <= 65) return "Medium";
  return "High";
};

export const bandColor = (band) => {
  switch (band) {
    case "Low":
      return { fg: "hsl(var(--risk-low))", bg: "hsl(var(--risk-low-bg))", hex: "#2f9e6b" };
    case "Medium":
      return { fg: "hsl(var(--risk-medium))", bg: "hsl(var(--risk-medium-bg))", hex: "#c98a0c" };
    default:
      return { fg: "hsl(var(--risk-high))", bg: "hsl(var(--risk-high-bg))", hex: "#c93838" };
  }
};

// subscore (0-100) -> color
export const subColor = (v) => {
  if (v <= 30) return "#2f9e6b";
  if (v <= 65) return "#c98a0c";
  return "#c93838";
};

export const PLATFORMS = ["Airbnb", "Stayz", "Booking.com", "Direct Booking", "Other"];
export const ACCOUNT_AGES = ["New", "Under 3 months", "3-12 months", "Over 12 months", "Unknown"];
export const LEAD_TIMES = ["Same day", "1-2 days", "3-7 days", "8-30 days", "30+ days"];
export const PROPERTY_TYPES = ["Apartment", "House", "Luxury home", "Waterfront", "High-rise", "Shared space"];
export const MESSAGE_QUALITIES = ["Clear", "Vague", "Demanding", "Unusual", "Unknown"];
export const PURPOSES = ["Holiday", "Work", "Family", "Event", "Unknown"];
export const YES_NO_UNKNOWN = ["Yes", "No", "Unknown"];
export const YES_NO = ["Yes", "No"];
export const ENTIRE_PRIVATE = ["Entire home", "Private room"];

// Evidence risk categories (derived) — labels + icons used in dashboard & Evidence Centre.
export const EVIDENCE_CATEGORIES = [
  { key: "refund_risk", label: "Refund risk", short: "Refund" },
  { key: "extortion_coercion_risk", label: "Extortion / coercion risk", short: "Extortion" },
  { key: "chargeback_risk", label: "Chargeback risk", short: "Chargeback" },
  { key: "property_damage_risk", label: "Property damage risk", short: "Damage" },
  { key: "party_disturbance_risk", label: "Party / disturbance risk", short: "Party" },
];

export const EVIDENCE_MESSAGE =
  "Reports can be generated for past, present or future bookings and may be used as supporting evidence for refund requests, review disputes, damage claims, chargebacks, extortion attempts and other guest-related disputes.";
